import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	actionsRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[8],
		justifyContent: 'space-between',
	},
	availableLeads: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[8],
	},
	body: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: typography.fontSizes.sm,
		minHeight: 0,
		overflowY: 'auto',
	},
	closeButton: {
		flex: 'none',
	},
	dayLabel: {
		paddingTop: THEME.space[8],
		width: 72,
	},
	dayRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.space[16],
	},
	dialogColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[16],
	},
	dialogRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[12],
	},
	dialogSelect: {
		width: 220,
	},
	drawerHeader: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		paddingBottom: THEME.space[8],
		justifyContent: 'space-between',
	},
	drawerTitleRow: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.space[12],
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[4],
		minWidth: 0,
	},
	fieldGrid: {
		display: 'grid',
		gap: THEME.space[12],
		gridTemplateColumns: '1fr 1fr',
	},
	fieldWide: {
		gridColumn: '1 / span 2',
	},
	fillTrigger: {
		background: colors.background.light,
		width: '100%',
	},
	footer: {
		background: colors.background.light,
		borderTop: `1px solid ${colors.border.light}`,
		bottom: 0,
		margin: 'auto 0 0',
		padding: THEME.space[16],
		position: 'sticky',
	},
	outcomeChildren: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
		paddingLeft: THEME.space[24],
	},
	outcomeGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
	},
	outcomeParent: {
		fontWeight: typography.fontWeights.semibold,
	},
	outcomeList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[16],
		paddingLeft: THEME.space[24],
	},
	drawerSection: {
		borderBottom: `1px solid ${colors.border.light}`,
		padding: THEME.space[16],
	},
	sectionBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[12],
		padding: `${THEME.space[16]}px ${THEME.space[4]}px ${THEME.space[4]}px`,
	},
	sectionChevron: {
		transform: 'rotate(90deg)',
		transition: 'transform 150ms ease-out',
		':is([data-panel-open] *)': {
			transform: 'rotate(-90deg)',
		},
	},
	sectionTrigger: {
		alignItems: 'center',
		background: 'transparent',
		border: 'none',
		color: colors.text.dark,
		cursor: 'pointer',
		display: 'flex',
		fontFamily: 'inherit',
		fontSize: typography.fontSizes.lg,
		justifyContent: 'space-between',
		padding: 0,
		width: '100%',
	},
	subLabel: {
		color: colors.text.dark,
		fontSize: typography.fontSizes.sm,
		margin: 0,
	},
	radioContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[8],
		paddingLeft: THEME.space[24],
	},
	radioGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.space[8],
	},
	tagBuilder: {
		background: colors.background.light,
		margin: 0,
		width: 'auto',
	},
	timeSelect: {
		background: colors.background.light,
		width: 120,
	},
	toEnd: {
		marginLeft: 'auto',
	},
});
